//Libs
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
//Componentes Material
import Grid from '@material-ui/core/Grid';
//Ícones
import BusinessIcon from '@material-ui/icons/Business';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import BuildIcon from '@material-ui/icons/Build';
//Relatórios
import RelatorioEmpresas from './relatorio/RelatorioEmpresas';

/**
 * Componente para exiber os relatórios e atalhos para o perfil Master Admin
 */
class DashboardMasterAdmin extends Component {
    render() {
        return (
            <Fragment>
                <Grid container spacing={1} >
                    <Grid item xs={12} sm={4} >
                        <Button startIcon={<BusinessIcon />} size="large" variant="contained" color="primary" component={Link} to="/empresa/add" style={{ width: '100%' }} >Adicionar empresa</Button>
                    </Grid>
                    <Grid item xs={12} sm={4} >
                        <Button startIcon={<AssignmentIndIcon />} size="large" variant="contained" color="primary" component={Link} to="/questionario/add" style={{ width: '100%' }} >Adicionar questionário</Button>
                    </Grid>
                    <Grid item xs={12} sm={4} >
                        <Button startIcon={<BuildIcon />} size="large" variant="contained" color="primary" component={Link} to="/administrador/add" style={{ width: '100%' }} >Adicionar administrador</Button>
                    </Grid>
                </Grid>
                <Grid container spacing={1} >
                    <RelatorioEmpresas />
                </Grid>
            </Fragment>
        );
    }
}

export default DashboardMasterAdmin;